"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBonusDto = instanceOfBonusDto;
exports.BonusDtoFromJSON = BonusDtoFromJSON;
exports.BonusDtoFromJSONTyped = BonusDtoFromJSONTyped;
exports.BonusDtoToJSON = BonusDtoToJSON;
exports.BonusDtoToJSONTyped = BonusDtoToJSONTyped;
/**
 * Check if a given object implements the BonusDto interface.
 */
function instanceOfBonusDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
function BonusDtoFromJSON(json) {
    return BonusDtoFromJSONTyped(json, false);
}
function BonusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'amount': json['amount'],
        'description': json['description'],
    };
}
function BonusDtoToJSON(json) {
    return BonusDtoToJSONTyped(json, false);
}
function BonusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'amount': value['amount'],
        'description': value['description'],
    };
}
//# sourceMappingURL=BonusDto.js.map